module.exports = __webpack_public_path__ + "img/img_4_step_bg.71503476.png";